import React from 'react';



const Contact = () => {
  return (
    <div className='mt-36 pl-8'>
      <h1>Contact</h1>
   
    </div>
    )
}
export default Contact ;